<template lang="html">
    <div>
        <div class="loader-wrap" v-if="!loaded">
            <div class="loader-content">
                <div class="loader">
                    <div class="loader__item">
                    </div>
                </div>
            </div>
        </div>

        <div class="content" v-else>
            <h1>Autoři blogu</h1>
            <v-layout class="layout--controls">
                <v-btn
                        color="primary"
                        type="submit"
                        class="button--top control"
                        @click="addArticleAuthor()"
                >Vytvořit autora</v-btn>
                <v-text-field
                        class="input--search control"
                        placeholder="Vyhledat"
                        outlined
                        v-model="search"
                ></v-text-field>
            </v-layout>
            <v-layout class="table-items">



                <v-data-table

                        :headers="headers"
                        :items="items"
                        :search="search"
                        :loading="false"
                        locale="cs"
                        item-key="name"
                        :items-per-page="30"
                        :mobile-breakpoint='0'
                        class="elevation-1 full-width frankjoy-table"
                >

                    <template slot="body" slot-scope="props">
                        <tbody>
                        <tr v-for="item in props.items" :key="item.id" >
                            <router-link :to="{name:'ArticleAuthorsDetail', params: {id: item.id}}" >
                                <td class="">
                                    <span v-if="item.image" class="image-table image-table--photo" :style="'background-image:url('+item.image+')'"></span>
                                    <span v-else class="image-table"></span>
                                </td>
                                <td class="">{{item.id}}</td>
                                <td class="">{{item.name}}</td>

                                <td class="right">
                                    <v-btn
                                            color="primary"
                                            type="submit"
                                            class="button--small"
                                    >Detail</v-btn>
                                </td>
                            </router-link>



                        </tr>
                        <div v-if="props.items.length == 0" class="text-no-results">
                            <p>Žádný autor nebyl nalezen</p>
                        </div>
                        </tbody>

                    </template>


                    <template slot="footer" slot-scope="totals">

                        <div class="table-footer"  v-bind:class="{'footer--no-results': totals.props.pagination.pageStop === 0}">
                            <div class="table-footer__text">
                                Počet autorů na stránce
                            </div>
                            <div class="table-footer__pages">
                                <span v-if="totals.props.pagination.pageStop > 0"><span class="table-footer__pages-bold">{{totals.props.pagination.pageStart + 1}}-{{totals.props.pagination.pageStop}}</span> z {{totals.props.pagination.itemsLength}}</span>
                                <span v-else><span class="table-footer__pages-bold">{{totals.props.pagination.pageStart}}-{{totals.props.pagination.pageStop}}</span> z {{totals.props.pagination.itemsLength}}</span>
                            </div>
                        </div>
                    </template>
                </v-data-table>


            </v-layout>
        </div>
    </div>
</template>


<script>
    import { mapState } from 'vuex';

    export default {
        name: 'ArticleAuthors',
        components: {
        },



        data() {
            return {
                loaded: false,
                search: '',
                headers: [
                    { text: '', value: 'image', sortable: false,  align: 'left',  },
                    { text: 'ID', value: 'id',  align: 'left',  },
                    { text: 'Jméno', value: 'name',  align: 'left',  },
                    { text: '', value: 'controls',  align: 'right',  }
                ],
                items: []
            }
        },

        created() {

            this.fetchData();


        },
        computed: {
            ...mapState(['profile']),

        },
        mounted(){

        },
        methods: {
            addArticleAuthor(){
                this.$router.push({name: 'ArticleAuthorsDetail', params: {id: 'add'}})
            },
            fetchData(){

                this.$axios.get('/admin/article-authors').then((response) => {
                    this.items = response.data.authors;
                    this.loaded = true;
                }).catch((e) => {
                    this.loaded = true;
                });
            }

        },
        watch: {

        }
    }
</script>


<style lang="scss">


</style>
